var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28813 5.4H19.5021C20.8801 5.4 21.8751 6.67 21.4971 7.948L19.8431 13.548C19.5881 14.408 18.7741 15 17.8481 15H8.69013C7.76313 15 6.94813 14.407 6.69413 13.548L4.28813 5.4ZM4.28813 5.4L3.57812 3M17.0781 21C17.4759 21 17.8575 20.842 18.1388 20.5607C18.4201 20.2794 18.5781 19.8978 18.5781 19.5C18.5781 19.1022 18.4201 18.7206 18.1388 18.4393C17.8575 18.158 17.4759 18 17.0781 18C16.6803 18 16.2988 18.158 16.0175 18.4393C15.7362 18.7206 15.5781 19.1022 15.5781 19.5C15.5781 19.8978 15.7362 20.2794 16.0175 20.5607C16.2988 20.842 16.6803 21 17.0781 21ZM9.07812 21C9.47595 21 9.85748 20.842 10.1388 20.5607C10.4201 20.2794 10.5781 19.8978 10.5781 19.5C10.5781 19.1022 10.4201 18.7206 10.1388 18.4393C9.85748 18.158 9.47595 18 9.07812 18C8.6803 18 8.29877 18.158 8.01746 18.4393C7.73616 18.7206 7.57812 19.1022 7.57812 19.5C7.57812 19.8978 7.73616 20.2794 8.01746 20.5607C8.29877 20.842 8.6803 21 9.07812 21Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersSvg);
export default __webpack_public_path__ + "static/media/orders_svg.2410d564680dfd6ee8cd9f499807fb2d.svg";
export { ForwardRef as ReactComponent };